export default __webpack_public_path__ + "static/media/665.f6ec12cc.png";